import script from "./owner-data-step.vue?vue&type=script&setup=true&lang=js"
export * from "./owner-data-step.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__